/**
 * Generates a zero-padded filename for a converted page.
 * The number of digits adjusts to the total page count
 * so that file sorting remains consistent.
 *
 * Example: createPageFilename('document', 1, 100, 'jpg')
 *          → 'document-page-001.jpg'
 */
export function createPageFilename(
  baseName: string,
  pageNumber: number,
  totalPages: number,
  extension: string,
): string {
  const digits = String(totalPages).length
  const padded = String(pageNumber).padStart(digits, '0')
  return `${baseName}-page-${padded}.${extension}`
}

/**
 * Strips the .pdf extension from a filename to use as the base name.
 */
export function getBaseName(filename: string): string {
  return filename.replace(/\.pdf$/i, '')
}
